import { render, staticRenderFns } from "./PspSettlements.vue?vue&type=template&id=19346944"
import script from "./PspSettlements.vue?vue&type=script&lang=js"
export * from "./PspSettlements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports